<template>
  <div>
    <div class="traveller-item md-layout">
      <div class="md-layout-item md-size-100 summary-row">
        <span class="bullet">
          <md-icon class="md-primary">person</md-icon>
          <router-link
            v-if="$allowed('crm.route.customer')"
            class="traveller-link"
            :to="{
              name: 'Customer Profile',
              params: { id: traveller.user_info.id }
            }"
            >{{ traveller.user_info.full_name }}</router-link
          >
          <span v-else>{{ traveller.user_info.full_name }}</span>
        </span>
        <span class="bullet" v-if="traveller.user_info.date_of_birth">
          <md-icon class="md-primary">cake</md-icon>
          {{ traveller.user_info.date_of_birth | formatDate }}
        </span>
        <span class="bullet" v-if="traveller.user_info.gender">
          <md-icon class="md-primary">{{ gender }}</md-icon>
          {{ traveller.user_info.gender }}
        </span>
      </div>

      <div class="md-layout-item md-size-15">
        <h6>Info</h6>
        <p>
          Passport: {{ traveller.user_info.traveller_info.passport_number }}
        </p>
        <p>
          Details Complete:
          <md-icon v-if="traveller.details_complete" class="text-success"
            >done</md-icon
          >
          <md-icon v-else class="text-danger">close</md-icon>
        </p>
      </div>
      <div class="md-layout-item md-size-15">
        <h6>Health</h6>
        <p class="subhead">Medical Info</p>
        <p v-if="traveller.user_info.traveller_info.medical_info">
          {{ traveller.user_info.traveller_info.medical_info }}
        </p>
        <p v-else>n/a</p>
        <p class="subhead">Dietary Info</p>
        <p v-if="traveller.user_info.traveller_info.dietary_info">
          {{ traveller.user_info.traveller_info.dietary_info }}
        </p>
        <p v-else>n/a</p>
      </div>
      <div class="md-layout-item md-size-20">
        <h6>Arrival</h6>
        <p class="subhead">Inbound Travel</p>
        <p>
          {{ traveller.travel_info.arrival_date | formatDate }} @
          {{ traveller.travel_info.arrival_time }}<br />
          <template v-if="traveller.travel_info.arrival_transport">
            {{ capitalize(traveller.travel_info.arrival_transport) }}<br />
          </template>
          <template v-if="traveller.travel_info.arrival_transport == 'flight'">
            Airport: {{ traveller.travel_info.arrival_airport }} [Flight Number
            : {{ traveller.travel_info.arrival_flight_number }}]
          </template>
          <template
            v-else-if="traveller.travel_info.arrival_transport == 'train'"
          >
            Train Station : {{ traveller.travel_info.arrival_train_station }}
          </template>
        </p>
        <p class="subhead">Pre-Trip Accom</p>
        <p v-if="traveller.travel_info.arrival_accommodation">
          {{ traveller.travel_info.arrival_accommodation }}
        </p>
        <p v-else>n/a</p>
      </div>
      <div class="md-layout-item md-size-20">
        <h6>Departure</h6>
        <p class="subhead">Outbound Travel</p>
        <p>
          {{ traveller.travel_info.departure_date | formatDate }} @
          {{ traveller.travel_info.departure_time }}<br />
          <template v-if="traveller.travel_info.departure_transport">
            {{ traveller.travel_info.departure_transport }}<br />
          </template>
          <template
            v-if="traveller.travel_info.departure_transport == 'flight'"
          >
            Airport: {{ traveller.travel_info.departure_airport }} [Flight
            Number : {{ traveller.travel_info.departure_flight_number }}]
          </template>
          <template
            v-else-if="traveller.travel_info.departure_transport == 'train'"
          >
            Train Station : {{ traveller.travel_info.departure_train_station }}
          </template>
        </p>
        <p class="subhead">Post-Trip Accom</p>
        <p v-if="traveller.travel_info.departure_accommodation">
          {{ traveller.travel_info.departure_accommodation }}
        </p>
        <p v-else>n/a</p>
      </div>
      <div class="md-layout-item md-size-15">
        <h6>Emergency</h6>
        <p>
          Contact:
          {{ traveller.user_info.traveller_info.emergency_contact_name }}
        </p>
        <p>
          Number:
          {{ traveller.user_info.traveller_info.emergency_contact_number }}
        </p>
        <p>
          Relationship:
          {{ traveller.user_info.traveller_info.emergency_relationship }}
        </p>
      </div>
      <div class="md-layout-item md-size-15">
        <h6>Extras</h6>
        <p v-if="traveller.travel_info.own_bike_details">
          Own Bike: {{ traveller.travel_info.own_bike_details }}
        </p>
        <ul class="extras" v-if="traveller.extras.length">
          <li v-for="extra in traveller.extras" :key="extra.id">
            <span class="title">{{ extra.extra.title }}</span>
            <span
              class="option"
              v-for="option in extra.options"
              :key="option.id"
            >
              {{ option.option.title }} : {{ option.selected_value }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _capitalize from "lodash/capitalize";

export default {
  props: {
    traveller: {}
  },

  computed: {
    gender: function() {
      return this.traveller.user_info.gender == "Male" ? "male" : "female";
    }
  },

  methods: {
    capitalize(value) {
      return _capitalize(value);
    }
  },

  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.traveller-item {
  padding: 5px;
  margin-bottom: 10px;

  h6 {
    margin: 0;
  }

  .subhead {
    font-weight: 500;
  }

  p {
    margin: 0 0 3px;
  }
  .summary-row {
    margin-bottom: 10px;
    border-top: 1px solid #bbbbbb;
    padding-top: 8px;
  }

  .extras {
    margin: 0;
    padding: 0;
    list-style-type: none;
    .title {
      font-weight: bold;
    }
    .option {
      padding-left: 7px;
      display: block;
    }
  }

  .bullet {
    display: inline-block;
    margin-right: 20px;

    i {
      margin-right: 5px;
    }
  }
}
</style>
